import { render } from "./cnt-table_cause_frequencies.vue?vue&type=template&id=f55b1d58&scoped=true"
const script = {}

import "./cnt-table_cause_frequencies.vue?vue&type=style&index=0&id=f55b1d58&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f55b1d58"]])

export default __exports__